<template>
  <div>
    <i v-for="(item,index) in list"  style="font-size: 30px;margin: 10px;cursor: pointer" @click="selectdatas(item)" :class="item"></i>
  </div>
</template>

<script>
import iconlist from "../../../assets/js/icon"
export default {
  name: "selecticon",
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.list = iconlist.icon.split("\n")
  },
  methods:{
    selectdatas(e){
      this.$emit("change",e)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/util/selecticon.vue